




















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class MobileCartButton extends Vue {
  @Prop() private readonly cartItemsCount!: number;
}
